import { AdminInput } from '@vgrubs/components';

type Props = {
  value: string;
  onChange: (value: string) => void;
};

/**
 * The admin password every manual action asks for (the backend's receivables
 * admin password). It is its own password, not the one this admin signed in
 * with, and the tooltip says so - typing the login password is the mistake
 * everyone makes first.
 *
 * `$password` with `type="text"` rather than `type="password"`, as on the
 * other admin password prompts: the field masks itself without the browser
 * offering to save it as this site's login.
 */
export const ReceivablesPasswordField = ({ value, onChange }: Props) => (
  <AdminInput
    label="Admin Password"
    tooltip="The separate admin password for outstanding balances, not the one you sign in with."
    placeholder="Enter here"
    value={value}
    onChange={(event) => onChange(event.target.value)}
    $password
    type="text"
    autoComplete="off"
  />
);
